<template>
  <v-dialog v-model="premiumDialog" :max-width="820">
    <v-card>
      <v-card-title class="title">
        <span class="ml-1">
        {{ $t("components.dialog.premium_feature.title", {subscription: subscriptionToUpgrade}) }}
        </span>

        <v-btn class="float-end" size="small" flat icon @click="premiumDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="d-flex justify-space-between align-center pt-2">
        <v-container class="pa-0">
          <v-row dense no-gutters>
            <v-col cols="12" md="6">
              <v-list class="list-features" density="compact">
                <v-list-item class="pl-0 no-truncate">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_1") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_2") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_3", {nr: 17}) }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForLite">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_4") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForLite">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_5") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForLitePlus">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_6") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForPowerPrep">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_7") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForExecutive">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_8") }}
                </v-list-item>
                <v-list-item class="pl-0 no-truncate" v-if="isAvailableForExecutive">
                  <v-icon class="mr-1" color="primary">mdi-check-circle</v-icon>
                  {{ $t("subscriptions.features.feature_9") }}
                </v-list-item>
              </v-list>

            </v-col>
            <v-col cols="12" md="6">
              <p class="call-to-action-heading mb-5">
                {{
                  $t("components.dialog.premium_feature.upgrade_title", {
                    subscription: subscriptionToUpgrade,
                  })
                }}
              </p>

              <p class="call-to-action-subheading mb-5">
                {{ $t("components.dialog.premium_feature.upgrade_subheading") }}
              </p>

              <v-btn @click="contactSales" color="primary" block>
                {{ $t("components.dialog.premium_feature.contact_sales") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'PremiumDialog',
  methods: {
    contactSales() {
      let url;
      switch (this.$i18n.locale) {
        case 'sv':
          url = 'https://myspeaker.se/kontakta-oss/';
          break;
        case 'fi':
          url = 'https://myspeaker.fi/ota-yhteytta-rhetorich/';
          break;
        case 'fr':
          url = 'https://myspeaker.fr/contactez-nous/';
          break;
        case 'de':
        case 'sp':
        default:
          url = 'https://myspeaker.com/contact-myspeaker-rhetorich/';
          break;
      }

      window.open(url, '_blank');
    },
  },
  computed: {
    premiumDialog: {
      get() {
        return this.$store.getters['dialogs/getPremiumDialog'];
      },
      set(value) {
        this.$store.dispatch('dialogs/setPremiumDialog', value);
      },
    },
    subscriptionToUpgrade() {
      return 'Executive';
    },
    isAvailableForLite() {
      return ['Lite', 'Lite+', 'PowerPrep', 'Executive'].includes(this.subscriptionToUpgrade);
    },
    isAvailableForLitePlus() {
      return ['Lite+', 'PowerPrep', 'Executive'].includes(this.subscriptionToUpgrade);
    },
    isAvailableForPowerPrep() {
      return ['PowerPrep', 'Executive'].includes(this.subscriptionToUpgrade);
    },
    isAvailableForExecutive() {
      return ['Executive'].includes(this.subscriptionToUpgrade);
    },
  },
};
</script>
<style scoped>
.title {
  color: #101319;
  font-family: Unbounded, serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 187.5% */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.call-to-action-heading {
  color: #101319;
  font-family: Unbounded, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.call-to-action-subheading {
  color: rgba(16, 19, 25, 0.70);
  font-family: Lora, serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.list-features {
  font-family: Lora, serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: normal;
}

</style>
